import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { useFilteredData } from '@ts-core/core/hooks/ui';

import { ProfessorActivityAnswer } from '../../types';
import { useActivityAnswers, useActivityAnswerActions } from '../../hooks';

import ActivityAnswersTable from '../../components/ActivityAnswersTable';

const ActivityAnswersPage = () => {
  const history = useHistory();

  const { courseId, activityId } = useParams<{ courseId: string; activityId: string }>();
  const { answers, loading } = useActivityAnswers({ courseId, activityId });
  const { onDeleteAnswer } = useActivityAnswerActions({ courseId, activityId });
  const { filteredData, onFilterData } = useFilteredData({ items: answers, fields: ['student.name', 'student.email'] });

  const onOpenActivityAnswer = useCallback(
    (activityAnswer: ProfessorActivityAnswer) => {
      history.push(`/${courseId}/activities/${activityId}/answers/${activityAnswer.id}`);
    },
    [history, courseId, activityId]
  );

  return (
    <ActivityAnswersTable
      answers={filteredData}
      loading={loading}
      onDeleteAnswer={onDeleteAnswer}
      onSearch={onFilterData}
      onAnswerClick={onOpenActivityAnswer}
    />
  );
};

export default ActivityAnswersPage;
